import type { GoalsTeamScoringProfile } from '../../../types';

interface TeamScoringPanelProps {
  profiles: {
    home: GoalsTeamScoringProfile;
    away: GoalsTeamScoringProfile;
  };
}

export function TeamScoringPanel({ profiles }: TeamScoringPanelProps) {
  const TeamProfile = ({ profile }: { profile: GoalsTeamScoringProfile }) => (
    <div className="goals-team-profile">
      <div className="goals-team-profile-header">
        {profile.team_logo && (
          <img src={profile.team_logo} alt="" className="goals-team-profile-logo" />
        )}
        <span className="goals-team-profile-name">{profile.team_name || 'Unknown'}</span>
      </div>

      <div className="goals-team-stats">
        <div className="goals-stat-row">
          <span className="goals-stat-label">Played</span>
          <span className="goals-stat-value">{profile.matches_played || '-'}</span>
        </div>
        <div className="goals-stat-row">
          <span className="goals-stat-label">Scored</span>
          <span className="goals-stat-value">
            {profile.goals_scored.total || '-'}
            {profile.goals_scored.avg != null && (
              <span className="goals-stat-avg"> ({profile.goals_scored.avg.toFixed(1)})</span>
            )}
          </span>
        </div>
        <div className="goals-stat-row">
          <span className="goals-stat-label">Conceded</span>
          <span className="goals-stat-value">
            {profile.goals_conceded.total || '-'}
            {profile.goals_conceded.avg != null && (
              <span className="goals-stat-avg"> ({profile.goals_conceded.avg.toFixed(1)})</span>
            )}
          </span>
        </div>
        <div className="goals-stat-row">
          <span className="goals-stat-label">Clean Sheets</span>
          <span className="goals-stat-value">{profile.clean_sheets || '-'}</span>
        </div>
        <div className="goals-stat-row">
          <span className="goals-stat-label">Failed to Score</span>
          <span className="goals-stat-value">{profile.failed_to_score || '-'}</span>
        </div>
        {profile.form && (
          <div className="goals-stat-row">
            <span className="goals-stat-label">Form</span>
            <div className="goals-form-display">
              {profile.form.split('').slice(-5).map((result, idx) => (
                <span
                  key={idx}
                  className={`goals-form-result goals-form-${result.toLowerCase()}`}
                >
                  {result}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="goals-panel goals-team-scoring-panel">
      <h4>Team Scoring Profiles</h4>
      <div className="goals-team-profiles-grid">
        <TeamProfile profile={profiles.home} />
        <TeamProfile profile={profiles.away} />
      </div>
    </div>
  );
}

export default TeamScoringPanel;
